export const AiEnhancementTypes = Object.freeze({
    OFFICIAL: 'official',
    CAMPAIGN: 'campaign',
    CAMPAIGN_UPDATE: 'campaign_update',
    PETITION: 'petition',
    OPINION: 'opinion',
    GROUP_OPINION: 'group_opinion',
    COMMENT: 'comment',
    NEWS: 'news',
    BLOG: 'blog',
    GENERAL: 'general',
});

export const AiEnhancementTones = Object.freeze({
    RESPECTFUL: 'respectful',
    URGENT: 'urgent',
    PASSIONATE: 'passionate',
    PERSUASIVE: 'persuasive',
    CONVERSATIONAL: 'conversational',
    INSPIRING: 'inspiring',
});

export const AiEnhancementTonesByType = Object.freeze({
    [AiEnhancementTypes.CAMPAIGN_UPDATE]: [
        { value: AiEnhancementTones.PERSUASIVE, label: 'Persuasive' },
        { value: AiEnhancementTones.CONVERSATIONAL, label: 'Conversational' },
        { value: AiEnhancementTones.INSPIRING, label: 'Inspiring' },
    ],
    // Default para otros tipos
    default: [
        { value: AiEnhancementTones.RESPECTFUL, label: 'Respectful' },
        { value: AiEnhancementTones.URGENT, label: 'Urgent' },
        { value: AiEnhancementTones.PASSIONATE, label: 'Passionate' },
    ],
});

export const AiEnhancementPositions = Object.freeze({
    FAVOR: 'favor',
    AGAINST: 'against',
});